import React from "react";
import { cn } from "../../utils/cn";

interface InfoCardProps {
  icon?: React.ComponentType<{ className?: string }> | React.ReactNode;
  title: string;
  description: string;
  className?: string;
  iconClassName?: string;
  variant?: "default" | "elevated" | "outlined";
}

const InfoCard: React.FC<InfoCardProps> = ({
  icon: Icon,
  title,
  description,
  className,
  iconClassName,
  variant = "default",
}) => {
  const isComponent = typeof Icon === "function";

  const baseClasses = "flex items-center p-4 rounded-xl";

  const variantClasses = {
    default:
      "bg-gradient-to-br from-primary/10 to-primary/5 border-l border-b border-primary/20",
    elevated: "bg-cloud border border-gray-100",
    outlined: "bg-transparent border-2 border-primary/30",
  };

  const iconBaseClasses =
    "w-12 h-12 rounded-full flex items-center justify-center text-primary mr-4 transition-all duration-300";

  const iconVariantClasses = {
    default: "bg-gradient-to-br from-primary/20 to-primary/10",
    elevated: "bg-primary/10 shadow-md",
    outlined: "bg-transparent border-2 border-primary/30",
  };

  return (
    <div className={cn(baseClasses, variantClasses[variant], className)}>
      {Icon && (
        <div
          className={cn(
            iconBaseClasses,
            iconVariantClasses[variant],
            iconClassName
          )}
        >
          {isComponent ? <Icon className="w-6 h-6" /> : Icon}
        </div>
      )}
      <div className="flex-1">
        <h3 className="font-semibold text-lg mb-1">{title}</h3>
        <p className="text-md font-medium leading-relaxed">{description}</p>
      </div>
    </div>
  );
};

export default InfoCard;
